import { useEffect } from "react";
import { useTransactions } from "@/hooks/useTransactions";
import TransactionList from "@/components/TransactionList";
import TransactionFilter from "@/components/TransactionFilter";
import { toast } from "sonner";
import { useLanguage } from "@/contexts/LanguageContext";

const ITEMS_PER_PAGE = 20;

const Index = () => {
  const { t } = useLanguage();

  const {
    transactions,
    meta,
    isLoading,
    isError,
    pagination,
    goToPage,
    filterByTransactionId,
    filterByInvoiceNumber,
    filterByProjectId,
    clearFilters,
    transactionIdFilter,
    invoiceNumberFilter,
    projectIdFilter,
  } = useTransactions(ITEMS_PER_PAGE);

  useEffect(() => {
    document.title = `Silvaconsult Registry | ${t("common.transactions")}`;
  }, [t]);

  useEffect(() => {
    if (isError) {
      toast.error(t("common.error"), {
        description: t("common.noData"),
      });
    }
  }, [isError, t]);

  return (
    <div className="min-h-screen bg-gray-50 bg-[silvaconsult-primary-100]">
      {/* Main content */}
      <div className="container max-w-6xl mx-auto px-4 py-8">
        <div className="mb-6">
          <h1 className="text-2xl font-medium">{t("transactions.title")}</h1>
          <p className="text-gray-500 mt-1">{t("transactions.description")}</p>
        </div>

        <div className="bg-white rounded-xl p-6 border border-gray-100 mb-6 shadow-sm">
          <TransactionFilter
            onFilter={filterByTransactionId}
            onFilterInvoice={filterByInvoiceNumber}
            onFilterProject={filterByProjectId}
            onClear={clearFilters}
            currentFilter={transactionIdFilter}
            currentInvoiceFilter={invoiceNumberFilter}
            currentProjectFilter={projectIdFilter}
          />

          <TransactionList
            transactions={transactions}
            isLoading={isLoading}
            meta={meta}
            onPageChange={goToPage}
            currentPage={pagination.page}
          />
        </div>
      </div>

      {/* Footer */}
      <footer className="py-8 text-center text-gray-500 text-sm">
        <div className="container mx-auto px-4">
          <p>© {new Date().getFullYear()} Transaction Registry</p>
        </div>
      </footer>
    </div>
  );
};

export default Index;
